export default {
  menu: {
    en: 'Menu',
  },

  mainMenu: {
    en: 'Main menu',
  },
}
